import axios from 'axios'
import i18n from '@/i18n'

export const validaRUC = function(valor, basemax = 11) {
  valor = valor.replace(/[^0-9]+/g, '')
  let result = false
  if (valor.length == 0) return result

  let numero_al = ''

  for (let i = 0; i < valor.length; i++) {
    let c = valor[i]

    // faz a substituição de letra por codigo ascii
    let codigo = c.charCodeAt(0)
    if (!(codigo >= 48 && codigo <= 57)) {
      //{ entre 0 e 9 }
      numero_al = `${numero_al}${codigo}`
    } else {
      numero_al = `${numero_al}${c}`
    }
  }

  let k = 2
  let total = 0
  for (let i = numero_al.length - 1; i > 0; i--) {
    if (k > basemax) k = 2
    let numero_aux = parseInt(numero_al[i - 1])
    total += numero_aux * k
    k++
  }

  let resto = total % basemax

  let digito = 0
  if (resto > 1) digito = basemax - resto

  let calculo = numero_al[numero_al.length - 1]

  result = digito == calculo

  return result
}

export const validaCpfCnpj = function(val) {
  val = val.trim()
  val = val.replace(/\./g, '')
  val = val.replace('-', '')
  val = val.replace('/', '')
  val = val.split('')

  if (val.length == 11) {
    let cpf = val
    let v1 = 0
    let v2 = 0
    let aux = false
    let i = 0
    let p = 0

    for (i = 1; cpf.length > i; i++) {
      if (cpf[i - 1] != cpf[i]) {
        aux = true
      }
    }

    if (aux == false) {
      return false
    }

    for (i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
      v1 += cpf[i] * p
    }

    v1 = (v1 * 10) % 11

    if (v1 == 10) {
      v1 = 0
    }

    if (v1 != cpf[9]) {
      return false
    }

    for (i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
      v2 += cpf[i] * p
    }

    v2 = (v2 * 10) % 11

    if (v2 == 10) {
      v2 = 0
    }

    if (v2 != cpf[10]) {
      return false
    } else {
      return true
    }
  } else if (val.length == 14) {
    let cnpj = val
    let v1 = 0
    let v2 = 0
    let aux = false
    let i = 0
    let p1 = 0
    let p2 = 0

    for (i = 1; cnpj.length > i; i++) {
      if (cnpj[i - 1] != cnpj[i]) {
        aux = true
      }
    }

    if (aux == false) {
      return false
    }

    for (i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
      if (p1 >= 2) {
        v1 += cnpj[i] * p1
      } else {
        v1 += cnpj[i] * p2
      }
    }

    v1 = v1 % 11

    if (v1 < 2) {
      v1 = 0
    } else {
      v1 = 11 - v1
    }

    if (v1 != cnpj[12]) {
      return false
    }

    for (i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
      if (p1 >= 2) {
        v2 += cnpj[i] * p1
      } else {
        v2 += cnpj[i] * p2
      }
    }

    v2 = v2 % 11

    if (v2 < 2) {
      v2 = 0
    } else {
      v2 = 11 - v2
    }

    if (v2 != cnpj[13]) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}

let requiredField = (propertyType, customErrorMessage) => {
  return (v) =>
    !!v ||
    customErrorMessage ||
    `${propertyType} ${i18n.t('validation-messages.requiredField')}.`
}

let minLength = (propertyType, minLength) => {
  return (v) => {
    if (!v) {
      return true
    }

    return (
      v.length >= minLength ||
      `${propertyType} ${i18n.t('validation-messages.minLength', {
        quantidade: minLength,
      })}.`
    )
  }
}
let maxLength = (propertyType, maxLength) => {
  return (v) =>
    (v && v.length <= maxLength) ||
    `${propertyType} ${i18n.t('validation-messages.maxLength', {
      quantidade: maxLength,
    })}.`
}

let emailFormat = (isRequired = false) => {
  // eslint-disable-next-line
  let regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

  return (v) => {
    if (!v) {
      if (isRequired) return i18n.t('validation-messages.requiredMail')
      return true
    }
    return (v && regex.test(v)) || i18n.t('validation-messages.emailInvalido')
  }
}

let dateValidation = (isRequired = false) => {
  // eslint-disable-next-line
  let regex = /^(?:(?:31([-\/.]?)(?:0[13578]|1[02]))\1|(?:(?:29|30)([-\/.]?)(?:0[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)\d{2})$|^(?:29([-\/.]?)02\3(?:(?:(?:1[6-9]|[2-9]\d)(?:0[48]|[2468][048]|[13579][26]))))$|^(?:0[1-9]|1\d|2[0-8])([-\/.]?)(?:(?:0[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/

  return (v) => {
    if (!v) {
      if (isRequired) return i18n.t('validation-messages.requiredField')
      return true
    }
    return (v && regex.test(v)) || i18n.t('validation-messages.dataInvalida')
  }
}

let formataDataBD = (ddmmyyyy) => {
  // dd/mm/yyyy -> yyyy-mm-dd
  if (!ddmmyyyy) return
  let date = ddmmyyyy.split(' ')[0].split('/')
  date = date[2] + '-' + date[1] + '-' + date[0]
  return date
}

let converterDataDB = (value) => {
  // yyyy-mm-dd -> dd/mm/yyyy
  if (!value) return
  let date = value.substring(0, 10).split('-')
  date = date[2] + '/' + date[1] + '/' + date[0]
  return date
}

let getTodayDateTimeLocal = () => {
  let time = new Date().toLocaleTimeString('pt-BR')
  let now = new Date().toISOString()
  const today = now.substr(0, 11) + time + 'Z'

  return today
}

let getFormatDigit = (value) => {
  let digit =
    value.substring(0, 2) < 10
      ? value.substring(0, 2).padStart(2, '0')
      : value.substring(0, 2)

  return digit
}

let formatDateToTimestamp = (value) => {
  //  2020-10-30T08:00 para 2020.10.31 08:00
  if (!value) return value

  let date = value.replace(/[^0-9]+/g, '').substring(0, 12)
  let nDate =
    date.substring(0, 4) +
    '.' +
    getFormatDigit(date.substring(4, 6)) +
    '.' +
    getFormatDigit(date.substring(6, 8))

  let time = date.slice(-4)

  let nTime =
    getFormatDigit(time.substring(0, 2)) +
    ':' +
    getFormatDigit(time.substring(2, 4)) +
    ':00'

  return nDate + ' ' + nTime
}

let formatDateToTimestamps = (value) => {
  //  2020-10-30T08:00 para 2020-10-31 08:00(:00 se tiver)
  if (!value) return value

  let date = value
    .replace('T', ' ')
    .replace('Z', '')
    .substring(0, value.length)
  return date
}

export const formatMaskPlanoContas = (value, mask) => {
  if (!value) return ''

  var toMask = value.replace(/[^0-9]+/g, '')
  const mascara = mask
  let result = ''
  let countTerm = 0

  for (let index = 0; index < mascara.length; index++) {
    if (!toMask[index - countTerm]) {
      break
    } else if (mascara[index] == '.') {
      result += mascara[index]
      countTerm++
    } else {
      result += toMask[index - countTerm] ?? ' '
    }
  }
  return result
}

export const formatMaskDocumento = (value, mask) => {
  if (!value) return ''

  var toMask = value.replace(/[^0-9]+/g, '')
  const mascara = mask
  let result = ''
  let countTerm = 0

  for (let index = 0; index < mascara.length; index++) {
    if (!toMask[index - countTerm]) {
      break
    } else if (
      mascara[index] == '.' ||
      mascara[index] == '-' ||
      mascara[index] == '/'
    ) {
      result += mascara[index]
      countTerm++
    } else {
      result += toMask[index - countTerm] ?? ' '
    }
  }
  return result
}

export const formatMaskCEP = (value, mask) => {
  if (!value) return ''

  var toMask = value.replace(/[^0-9]+/g, '')
  const mascara = mask
  let result = ''
  let countTerm = 0

  for (let index = 0; index < mascara.length; index++) {
    if (!toMask[index - countTerm]) {
      break
    } else if (mascara[index] == '.' || mascara[index] == '-') {
      result += mascara[index]
      countTerm++
    } else {
      result += toMask[index - countTerm] ?? ' '
    }
  }
  return result
}

export const formatMaskDate = (value, mask = '##/##/####') => {
  if (!value) return ''

  var toMask = value.replace(/[^0-9]+/g, '')
  const mascara = mask
  let result = ''
  let countTerm = 0

  for (let index = 0; index < mascara.length; index++) {
    if (!toMask[index - countTerm]) {
      break
    } else if (mascara[index] == '/' || mascara[index] == '-') {
      result += mascara[index]
      countTerm++
    } else {
      result += toMask[index - countTerm] ?? ' '
    }
  }
  return result
}

export const convertImage = (image) => {
  if (image) {
    var bytes = new Uint8Array(image)
    var binary = bytes.reduce((data, b) => (data += String.fromCharCode(b)), '')
    image = 'data:image/jpeg;base64,' + Buffer.from(binary, 'base64')
  }
  return image
}

let consultaViaCep = async (cep) => {
  cep = cep.replace(/[^0-9]+/g, '')
  const requestUrl = 'https://viacep.com.br/ws/' + cep + '/json/'
  try {
    const { data } = await axios.get(requestUrl)
    return data
  } catch (e) {
    console.error('erro', e)
  }
}

let consultaCepRepublicaVirtual = async (cep) => {
  cep = cep.replace(/[^0-9]+/g, '')
  const requestUrl =
    'http://republicavirtual.com.br/web_cep.php?cep=' + cep + '&formato=jsonp'
  try {
    const { data } = await axios.get(requestUrl)
    return data
  } catch (e) {
    console.error('erro', e)
  }
}

let eventKeyPress = ($event) => {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which
  // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
  if (keyCode < 48 || keyCode > 57) {
    // 46 is dot
    $event.preventDefault()
  }
}

let translateList = (list) => {
  return list.map((element) => {
    if (element.label && i18n.te(`labels.${element.label}`))
      element.text = i18n.t(`labels.${element.label}`)

    return element
  })
}
let encodeQueryValues = (query) => {
  Object.keys(query).forEach((key) => {
    if (query[key] !== '' && typeof query[key] == 'string')
      query[key] = encodeURIComponent(query[key])
  })
  return query
}

let verifyOrderTiming = (orderIfood) => {
  if (orderIfood.orderTiming == 'SCHEDULED') {
    const now = new Date()
    const createdAt = new Date(orderIfood.preparationStartDateTime)
    const diff = new Date(now - createdAt)

    // const time = {
    //   hour: diff.getUTCHours(),
    //   minute: diff.getUTCMinutes(),
    // }

    // console.log(time, diff)
    return diff < 0
  }
}

let addMinutesToDate = (date, minutes) => {
  Date.prototype.addMinutes = function(value) {
    this.setMinutes(this.getMinutes() + value)
  }

  let newDate = new Date(date)

  newDate.addMinutes(minutes)

  return newDate
}
export {
  requiredField,
  minLength,
  maxLength,
  emailFormat,
  dateValidation,
  getTodayDateTimeLocal,
  getFormatDigit,
  formatDateToTimestamps,
  formatDateToTimestamp,
  formataDataBD,
  converterDataDB,
  consultaViaCep,
  consultaCepRepublicaVirtual,
  eventKeyPress,
  translateList,
  encodeQueryValues,
  verifyOrderTiming,
  addMinutesToDate,
}
